<h2>
  @if (title()) {
    {{ title() }}
  } @else {
    <ng-content select="[title]" />
    @if (mode() === readonly) {
      <ng-content select="[title-readonly]" />
    } @else {
      <ng-content select="[title-edit]" />
    }
  }
</h2>
<div class="d-flex justify-content-end my-2">
  @if (mode() === readonly) {
    <div class="d-flex align-items-center w-100">
      <div class="d-flex align-items-center flex-grow-1">
        <ng-content select="[toolbar]" />
      </div>
      <div class="ms-auto d-flex align-items-center gap-2">
        @if (showReadOnlyLabel()) {
          <span class="text-muted ap-font-weight-normal">
            {{ 'countryInformation.readOnly' | translate }}
          </span>
        }
        @if (canEdit()) {
          <ap-button
            btnType="primary"
            [label]="'shared.edit' | translate"
            (onClick)="edit()" />
        }
      </div>
    </div>
  } @else {
    <div class="d-flex align-items-center w-100">
      <div class="d-flex align-items-center flex-grow-1">
        <ng-content select="[toolbar-edit]" />
      </div>
      <div class="d-flex gap-1 ms-auto">
        <ap-button
          btnType="secondary"
          [label]="'shared.cancel' | translate"
          (onClick)="cancelHandler()" />
        <ap-button
          btnType="primary"
          [label]="'shared.save' | translate"
          [disabled]="hasNotChanges() || disableSaveButton()"
          (onClick)="saveHandler()" />
      </div>
    </div>
  }
</div>
<ng-content select="[after-toolbar]" />
@if (mode() === readonly) {
  <ng-content select="[after-toolbar-readonly]" />
} @else {
  <ng-content select="[after-toolbar-edit]" />
}
<div class="p-4 information-text border rounded">
  @if (mode() === readonly) {
    <gstar-editor
      [title]="title()"
      [mode]="readonly"
      [content]="content() | blankLinks | safe: 'html'" />
  } @else {
    <gstar-editor
      #editor
      [title]="title()"
      [mode]="editMode"
      [allowInternalLinks]="allowInternalLinks()"
      [content]="content() | blankLinks | safe: 'html'" />
  }
</div>
